<!-- @format -->

<div>
  @for (studyGroupSet of studyGroupSets; track studyGroupSet) {
    <div class="study-sub-group-set">
      <div class="study-group-set-title">
        {{ studyGroupSet.name | localizedString }}
      </div>
      @for (studySubGroup of studyGroupSet.studySubGroups; track studySubGroup) {
        <div class="study-group-set-content">
          <sis-study-sub-group-structure [studySubGroup]="studySubGroup" [language]="language"> </sis-study-sub-group-structure>
        </div>
      }
    </div>
  }
</div>
